import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { loginUser } from "../../actions/AuthAction";
import swal from "sweetalert";

const LoginModal = ({ isOpen, toggle }) => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginProses, setLoginProses] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (event) => {
    setLoginProses(true);
    event.preventDefault();

    if (email && password) {
      loginUser(email, password, setLoginProses, history);
    } else {
      setLoginProses(false);
      swal("Failed", "Maaf Email dan Password Harus Diisi", "error");
    }
  };

  const handleToggle = () => {
    // Reset form ketika modal ditutup
    if (isOpen) {
      setEmail("");
      setPassword("");
      setLoginProses(false);
    }
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleToggle}
      centered
      style={{ maxWidth: isMobile ? "95%" : "500px" }}
    >
      <div style={{ position: "relative", overflow: "hidden" }}>
        {/* Banner Section */}
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f8f9fa",
          }}
        >
          <img
            src="/Banner.png"
            alt="Banner"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Modal Header */}
        <ModalHeader
          toggle={handleToggle}
          style={{
            borderBottom: "2px solid #f1f3f5",
            padding: isMobile ? "15px 20px" : "20px 30px",
            background: "#ffffff",
          }}
        >
          <h4
            style={{
              margin: 0,
              color: "#2d3436",
              fontWeight: "500",
              fontSize: isMobile ? "1.1rem" : "1.25rem",
            }}
          >
            Masuk ke Akun
          </h4>
        </ModalHeader>

        {/* Modal Body */}
        <ModalBody style={{ padding: isMobile ? "20px 15px" : "30px" }}>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label
                for="email"
                style={{
                  fontWeight: "500",
                  color: "#2d3436",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                }}
              >
                Email Address
              </Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={email}
                placeholder="Masukkan Email"
                onChange={(event) => setEmail(event.target.value)}
                required
                style={{
                  borderRadius: "10px",
                  border: "1px solid #e9ecef",
                  padding: isMobile ? "10px 12px" : "12px 15px",
                  marginTop: "8px",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              />
            </FormGroup>

            <FormGroup>
              <Label
                for="password"
                style={{
                  fontWeight: "500",
                  color: "#2d3436",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                }}
              >
                Password
              </Label>
              <Input
                type="password"
                name="password"
                id="password"
                value={password}
                placeholder="Masukkan Password"
                onChange={(event) => setPassword(event.target.value)}
                required
                style={{
                  borderRadius: "10px",
                  border: "1px solid #e9ecef",
                  padding: isMobile ? "10px 12px" : "12px 15px",
                  marginTop: "8px",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              />
            </FormGroup>

            <div style={{ marginTop: isMobile ? "20px" : "25px" }}>
              {loginProses ? (
                <Button
                  color="primary"
                  type="submit"
                  disabled
                  block
                  style={{
                    borderRadius: "25px",
                    padding: isMobile ? "10px" : "12px",
                    fontSize: isMobile ? "0.9rem" : "1rem",
                    fontWeight: "500",
                    background: "#e63946",
                    border: "none",
                  }}
                >
                  <Spinner size="sm" color="light" /> Memproses...
                </Button>
              ) : (
                <Button
                  color="primary"
                  type="submit"
                  block
                  style={{
                    borderRadius: "25px",
                    padding: isMobile ? "10px" : "12px",
                    fontSize: isMobile ? "0.9rem" : "1rem",
                    fontWeight: "500",
                    background: "#e63946",
                    border: "none",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#d62828";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#e63946";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  Masuk
                </Button>
              )}
            </div>
          </form>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default LoginModal;
